import { render, staticRenderFns } from "./MainSideBar.vue?vue&type=template&id=36f4b95b"
import script from "./MainSideBar.vue?vue&type=script&lang=ts"
export * from "./MainSideBar.vue?vue&type=script&lang=ts"
import style0 from "./MainSideBar.vue?vue&type=style&index=0&id=36f4b95b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAvatar,VBanner,VBtn,VIcon,VNavigationDrawer})
